import {
  EXPLORER_ADD_FOLDER_TOGGLED,
  EXPLORER_ADD_PAGE_TOGGLED,
  EXPLORER_CREATE_MASTER_COMPONENT_TOGGLED
} from './const';

/**
 * toggle the add folder input on the explorer pane
 * @returns {object} an action object
 */
export const toggleUIAddFolder = () => ({
  type: EXPLORER_ADD_FOLDER_TOGGLED
});

/**
 * action to show/hide add page dialog
 * @returns {object} an action object
 */
export const toggleAddPage = () => ({
  type: EXPLORER_ADD_PAGE_TOGGLED
});

/**
 * action to show/hide create master component dialog
 * @returns {object} an action object
 */
export const toggleCreateMasterComponent = () => ({
  type: EXPLORER_CREATE_MASTER_COMPONENT_TOGGLED
});
